import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
  title: {
    fontSize: 8,
  },
  secondTitle: {
    fontSize: 8,
    marginLeft: 10,
  },
  headerText: {
    fontSize: 8,
    padding: '0px 12px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#E9E9E9',
    borderRadius: '2px',
    padding: '5px 5px',
    justifyContent: 'space-between',
    marginTop: '5px',
    minHeight: '16px',
  },
  opaqueWrapper: {
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid black',
    borderRadius: '2px',
    padding: '5px 5px',
    justifyContent: 'space-between',
    marginTop: '5px',
  },
  infoRow: {
    display: 'flex',
    padding: '5px 5px',
    flexDirection: 'row',
    fontSize: 7,
    justifyContent: 'space-between',
  },
});
